import { FC, useState } from "react";
import styled, { css } from "styled-components";

import { CloseButton, StyledDialog } from "@/components/AlertDialogs/Dialog";
import Button from "@/components/Button";
import { Modal } from "@/components/Modal";
import Text from "@/components/Text";
import { ReleaseStatusEnum } from "@/utils/enums";

const Dialog = styled(StyledDialog)``;

const Heading = styled(Text)`
  margin: 0 0 24px;
`;

const List = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
`;

const Footer = styled.div`
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
`;

const StyledButton = styled(Button)<{ $isActive: boolean }>`
  font-weight: 600;
  ${({ theme, $isActive }) =>
    $isActive &&
    css`
      border-color: ${theme.colors.purple} !important;
    `};
`;

interface Props {
  onClose: () => void;
  isSubmitting: boolean;
  onSubmit: (status: ReleaseStatusEnum) => Promise<void>;
  disableSchedule?: boolean;
}

const DistributionScheduleStatusModal: FC<Props> = ({
  onClose,
  isSubmitting,
  onSubmit,
  disableSchedule = false,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<ReleaseStatusEnum>();

  const onConfirm = async () => {
    await onSubmit(selectedStatus!);
    onClose();
  };

  return (
    <Modal zIndex={50}>
      <Dialog
        initial={{ scale: 0.3 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.3 }}
      >
        <CloseButton onClick={onClose} type="button">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13L1 1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CloseButton>
        <Heading $type="heading2">Choose type:</Heading>
        <List>
          <StyledButton
            type="button"
            color="secondary"
            $isActive={selectedStatus === ReleaseStatusEnum.DRAFT}
            onClick={() => setSelectedStatus(ReleaseStatusEnum.DRAFT)}
          >
            Draft
          </StyledButton>
          <StyledButton
            type="button"
            color="secondary"
            $isActive={selectedStatus === ReleaseStatusEnum.PREPARED}
            onClick={() => setSelectedStatus(ReleaseStatusEnum.PREPARED)}
          >
            Prepared
          </StyledButton>
          <StyledButton
            type="button"
            color="secondary"
            disableSchedule={disableSchedule}
            $isActive={selectedStatus === ReleaseStatusEnum.WAITING}
            onClick={() => setSelectedStatus(ReleaseStatusEnum.WAITING)}
          >
            Schedule
          </StyledButton>
        </List>
        <Footer>
          <Button
            loading={isSubmitting}
            disabled={isSubmitting || !selectedStatus}
            type="button"
            onClick={onConfirm}
          >
            Confirm
          </Button>
          <Button onClick={onClose} color="secondary" type="button">
            Cancel
          </Button>
        </Footer>
      </Dialog>
    </Modal>
  );
};

export default DistributionScheduleStatusModal;
